export default {
  "content": "<circle cx=\"6.5\" cy=\"6.5\" r=\"6.5\" fill=\"#fff\"/><g clip-path=\"url(#a)\"><path fill=\"#4E4EDA\" d=\"M6.5 1.5a5 5 0 100 10 5 5 0 000-10m1.53 5.56l-1.25.624a.627.627 0 01-.84-.28l-1.25-2.5a.626.626 0 011.12-.558l.97 1.94.69-.345a.624.624 0 11.56 1.118\"/></g><defs><clipPath id=\"a\"><rect width=\"10\" height=\"10\" x=\"1.5\" y=\"1.5\" fill=\"#fff\" rx=\"5\"/></clipPath></defs>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "13",
    "height": "13",
    "fill": "none"
  }
};